import { Component, Input, OnInit, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { MbsPopupType, MbsSize } from 'mbs-ui-kit';
import { InstallationMode } from 'mbs-ui-shared@components/add-computer/add-computer.constants';
import { WizardForm } from 'mbs-ui-shared@components/add-computer/add-computer.types';
import { getTilesConfig } from 'mbs-ui-shared@components/add-computer/steps/download-and-install/download-and-install.constants';
import { BuildsFacade } from 'mbs-ui-shared@facades/builds.facade';
import { HelpService } from 'mbs-ui-shared@help/help.service';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import Brand from 'mbs-ui-shared@models/Brand';
import { Build, BuildOsType } from 'mbs-ui-shared@models/build';
import { AgentType } from 'mbs-ui-shared@models/Computer';

import { AlertComponent, ButtonComponent, InputLabelComponent } from 'mbs-ui-kit';

import { DownloadBuildComponent } from 'mbs-ui-shared@components/download-build/download-build.component';

import { AsyncPipe, CommonModule } from '@angular/common';

import { CanPipe } from 'ability';

@UntilDestroy()
@Component({
  selector: 'add-computer-wizard-download-and-install-step',
  templateUrl: './download-and-install.component.html',
  styleUrls: ['./download-and-install.component.scss', '../../add-computer.component.scss'],
  imports: [AlertComponent, AsyncPipe, ButtonComponent, CanPipe, CommonModule, DownloadBuildComponent, InputLabelComponent, I18NextPipe]
})
export class DownloadAndInstallComponent implements OnInit {
  private buildsFacade = inject(BuildsFacade);
  private i18N = inject(I18NextPipe);
  private helpService = inject(HelpService);

  public readonly permissionsEnum = PermissionsEnum;
  public readonly size = MbsSize;
  public readonly agentType = AgentType;
  public readonly tilesConfig = getTilesConfig(this.i18N);
  public readonly os = BuildOsType;
  public readonly mbsPopupType = MbsPopupType;

  public buildsSettings$ = this.buildsFacade.buildsSettings$;
  public openedPanelIds = [];
  public buildsInProgress = [];
  public installationModeEnum = InstallationMode;

  @Input() displayedBuilds: Build[];
  @Input() licensedBrandList: Brand[];
  @Input() wizardForm: WizardForm;
  @Input() networkDiscoveryBuild: Build;

  ngOnInit(): void {
    this.buildsFacade.buildsInProgress$.subscribe((buildsInProgress) => {
      this.buildsInProgress = buildsInProgress;
    });
  }

  public onBuildPanelClick({ panelId, opening }: { panelId: string; opening: boolean }) {
    opening && (this.openedPanelIds = [panelId]);
  }

  public openRMMCEHelpPage(): void {
    window.open(this.helpService.getHelpLink('/remote-management/rmm-service/rmm-ce'), '_blank');
  }
}
